"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// NOTE: This file is manipulated by the CI pipeline, so if you make changes be sure you aren't breaking the CI pipeline.
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParser = exports.ExtensionKind = exports.MaterialTypeNameCollection = exports.ModelParsingOption = exports.TraversalStatus = void 0;
var parser_1 = require("./parser");
Object.defineProperty(exports, "TraversalStatus", { enumerable: true, get: function () { return parser_1.TraversalStatus; } });
Object.defineProperty(exports, "ModelParsingOption", { enumerable: true, get: function () { return parser_1.ModelParsingOption; } });
var parser_2 = require("./parser");
Object.defineProperty(exports, "MaterialTypeNameCollection", { enumerable: true, get: function () { return parser_2.MaterialTypeNameCollection; } });
Object.defineProperty(exports, "ExtensionKind", { enumerable: true, get: function () { return parser_2.ExtensionKind; } });
Object.defineProperty(exports, "createParser", { enumerable: true, get: function () { return parser_2.createParser; } });
//# sourceMappingURL=index.js.map